import { Component, OnInit } from "@angular/core";
import { DateService } from "@root/shared/service/date.service";
import { TranslateService } from "@root/shared/service/translate.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { NzModalRef } from "ng-zorro-antd/modal";

/**
 * @deprecated
 */
@Component({
  selector: "host-stop-house-calendar",
  templateUrl: "./stop-house-calendar.component.html",
  styleUrls: ["./stop-house-calendar.component.scss"],
})
export class WillDeprecated_StopHouseCalendarComponent implements OnInit {
  selectedDates: string[] = [];

  get selectedDatesInfo() {
    const length = this.selectedDates.length;
    if (!length) {
      return null;
    }
    return this.t.t(
      length > 1 ? "component.search.selected_discontinuous_nights" : "component.search.selected_discontinuous_night",
      {
        start: this.dateSrv.format(this.selectedDates[0], ["YMD"]),
        end: this.dateSrv.format(this.selectedDates[length - 1], ["YMD"]),
        len: length,
      },
    );
  }
  constructor(
    private modalRef: NzModalRef,
    private msg: NzMessageService,
    private t: TranslateService,
    private dateSrv: DateService,
  ) {}

  ngOnInit() {}

  onCancel() {
    this.modalRef.destroy();
  }

  onConfirm() {
    this.modalRef.destroy({
      dates: this.selectedDates,
    });
  }
}
